import { create } from 'zustand';

interface IPracticeFilterStoreState {
  modality: string[];
  rate: string[];
  essay: string[];
  setEssay: (essay: string[]) => void;
  setModality: (modality: string[]) => void;
  setRate: (rate: string[]) => void;
  reset: () => void;
}

export const practiceFilterStoreStore = create<IPracticeFilterStoreState>(
  (set) => ({
    modality: [],
    rate: [],
    essay: [],
    setModality: (modality: string[]) => set({ modality: modality }),
    setRate: (rate: string[]) => set({ rate }),
    setEssay: (essay: string[]) => set({ essay }),
    reset: () => set({
      modality: [],
      rate: [],
      essay: []
    })
  }),
);